var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(_vm.componentType === 'link' ? 'a' : 'div', _vm._b({
    tag: "component",
    staticClass: "media h-100 w-100 position-relative",
    class: [_vm.overlayType, {
      'has-overlay': _vm.hasOverlay
    }],
    style: [_vm.videoMp4 || _vm.videoWebm || _vm.src ? 'cursor: pointer' : 'cursor: initial']
  }, "component", _vm._d({}, [_vm.href, _vm.url])), [_c('RegularMediaArtDirection', {
    staticClass: "h-100 w-100",
    attrs: {
      "src": _vm.src,
      "srcsets": _vm.srcsets,
      "alt": _vm.alt,
      "video-mp4": _vm.videoMp4,
      "video-webm": _vm.videoWebm,
      "ratio-img": _vm.ratioImg,
      "auto-play": _vm.autoPlay,
      "play-color": _vm.iconPlayColor
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };